// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"1775a81a","648":"608c2949"}[chunkId] + ".chunk.js";
};